import { API_URL, tenantConfig } from 'config';
import AuthService from 'services/AuthService';
import { HttpService } from 'services/HttpService';
import {
  CreateDirectoryListingsResponse,
  DirectoryListings,
  UpdateDirectoryListing,
  UpdateDirectoryListingsResponse,
} from 'store/types/DirectoryListing';
import { httpRequestWrapper } from 'util/Request';

class DirectoryListingService {
  public static getDirectoryListings(companyId: string): Promise<DirectoryListings> {
    return new Promise((resolve, reject) => {
      httpRequestWrapper(
        HttpService.get(`${API_URL}/directory/listings/${companyId}`, {
          headers: {
            TenantId: tenantConfig.id,
            authorization: AuthService.getBearerToken(),
          },
        }),
        resolve,
        reject
      );
    });
  }

  public static createDirectoryListings(
    companyId: string,
    individualId: string,
    approvalRequestedBy?: string
  ): Promise<CreateDirectoryListingsResponse> {
    return new Promise((resolve, reject) => {
      httpRequestWrapper(
        HttpService.post(`${API_URL}/directory/listings`, {
          data: {
            companyId,
            individualId,
            approvalRequestedBy,
          },
          headers: {
            TenantId: tenantConfig.id,
            authorization: AuthService.getBearerToken(),
          },
        }),
        resolve,
        reject
      );
    });
  }

  public static updateDirectoryListings(
    companyId: string,
    directoryNetworkId: string,
    listings: UpdateDirectoryListing[]
  ): Promise<UpdateDirectoryListingsResponse> {
    return new Promise((resolve, reject) => {
      httpRequestWrapper(
        HttpService.put(`${API_URL}/directory/listings`, {
          data: {
            companyId,
            directoryNetworkId,
            listings,
          },
          headers: {
            TenantId: tenantConfig.id,
            authorization: AuthService.getBearerToken(),
          },
        }),
        resolve,
        reject
      );
    });
  }
}

export default DirectoryListingService;
